import { List } from 'immutable';

export const getTotalCartItems = cart => cart.get('cart', List()).reduce((memory, item) => memory + item.get('quantity'), 0);



// WEBPACK FOOTER //
// ./src/util/getTotalCartItems.js